import TeamDetailMember from '@/screens/TeamDetailMember';

export default function PrivateTabsTeamMainIndexRoute() {
  return <TeamDetailMember memberPathname="/team/member/[personId]" />;
}
